var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "../SubElementComponent";
import { defaults, heapDefaults, mutable } from "../../style";
import { deepAwaitMixin } from "../../mixins/DeepAwaitMixin";
let SetComponent = class SetComponent extends deepAwaitMixin(LitElement) {
    get subElements() {
        return this.el.slice(1);
    }
    // gives roughly a 3x5 rectangular ratio, square is too, err,
    // 'square' and boring
    get numRows() {
        let numRows = Math.round(Math.sqrt(this.subElements.length));
        if (numRows > 3) {
            numRows -= 1;
        }
        return numRows;
    }
    get numCols() {
        return Math.ceil(this.subElements.length / this.numRows);
    }
    exists(i, j) {
        return i * this.numCols + j < this.subElements.length;
    }
    render() {
        return html `
            <label>set</label>
            <table>
                ${Array(this.numRows).fill(0).map((_, i) => html `
                    <tr>
                        ${Array(this.numCols).fill(0).map((_, j) => this.exists(i, j) ? html `
                            <td>
                                <tc-sub-element .el=${this.subElements[i * this.numCols + j]}>
                                </tc-sub-element>
                            </td>
                        ` : html ``)}
                    </tr>
                `)}
            </table>
        `;
    }
};
SetComponent.styles = [defaults, heapDefaults, mutable];
__decorate([
    property({ type: Array })
], SetComponent.prototype, "el", void 0);
SetComponent = __decorate([
    customElement('tc-set')
], SetComponent);
export { SetComponent };
//# sourceMappingURL=SetComponent.js.map